import React from "react";
import { Spinner } from "@yoast/ui-library";
import * as styles from "./CheckoutLoading.module.scss";

/**
 * Loading page shown in new window while waiting for checkout URL.
 *
 * @returns {JSX.Element} The CheckoutLoading component.
 */
const CheckoutLoading = () => {
	return (
		<div className={ styles.container }>
			<div className={ styles.content }>
				<div className={ styles.titleRow }>
					<Spinner />
					<h1 className={ styles.title }>Preparing your checkout...</h1>
				</div>
				<p className={ styles.message }>You&apos;ll be redirected to the checkout page in a moment.</p>
			</div>
		</div>
	);
};

export default CheckoutLoading;
